<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Date
            </th>
            <th class="text-left">
              Through
            </th>
            <th class="text-left">
              Paid
            </th>
            <th class="text-left">
              Return
            </th>
            <th class="text-left">
              Total Amount
            </th>
            <th class="text-left">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in tableInfo" :key="item._id">
            <td>{{ dateBN(item.date) }}</td>
            <td>{{ item.through }}</td>
            <td>{{ toBN(item.paid) }}/-</td>
            <td>{{ toBN(item.return) }}/-</td>
            <td>{{ toBN(item.total_paid) }}/-</td>
            <td>
              <v-btn color="blue" icon @click="handleEditModal(item)"> <v-icon>mdi-pencil</v-icon> </v-btn>
              <!-- <v-btn color="red" class="ml-2" icon @click="deleteInfo(item)"> <v-icon>mdi-delete</v-icon> </v-btn> -->
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-dialog v-model="dialog" max-width="600">
      <v-form ref="editForm" @submit.prevent="handleEditSubmit">
        <v-card rounded="lg">
          <v-card-title class="text-h5">
            Edit Information
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6">
                <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :value="date" label="Payment date" filled v-bind="attrs" v-on="on" />
                  </template>
                  <v-date-picker ref="picker" v-model="date"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field filled label="Source" v-model="source" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field type="number" filled label="Paid" v-model="paidAmount" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field type="number" filled label="Return" v-model="returnAmount" />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" text class="mb-4 text-capitalize" @click="dialog = false">Cancel</v-btn>
            <v-btn color="primary" depressed class="mb-4 text-capitalize" type="submit">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <app-snackbar />
  </div>
</template>

<script>
import AppSnackbar from './common/AppSnackbar.vue';
export default {
  components: { AppSnackbar },
  props: ['tableInfo'],
  data: () => ({
    date: '',
    dialog: false,
    id: '',
    menu: false,
    paidAmount: '',
    returnAmount: '',
    source: '',
  }),
  methods: {
    toBN(value) {
      return value.toLocaleString('bn-BD');
    },
    dateBN(date) {
      const baseData = { '0': '০', '1': '১', '2': '২', '3': '৩', '4': '৪', '5': '৫', '6': '৬', '7': '৭', '8': '৮', '9': '৯' };

      let resStr = '';
      for (let i = 0; i < date.length; i++) {
        if (date[i] in baseData) {
          resStr += baseData[date[i]];
        } else {
          resStr += date[i];
        }
      }
      return resStr;
    },
    handleEditModal(item) {
      console.log(item);
      this.dialog = true;
      this.id = item._id;
      this.date = item.date;
      this.paidAmount = item.paid;
      this.returnAmount = item.return;
      this.source = item.through;
    },
    handleEditSubmit() {
      this.$store.dispatch('updatedMemberInformation', { _id: this.id, date: this.date, through: this.source, paid_tk: this.paidAmount, return_tk: this.returnAmount });
      this.dialog = false;
    },
    // deleteInfo(value) {
    //   this.$store.dispatch("deleteCreditInfo", { rowId: value.id, criteriaId: this.$route.params.id });
    // },
  },
};
</script>
